import { TabsType } from 'components/Tabs/Tabs';
import { Translation } from 'hooks/useTranslation/useTranslation';

export const createSettingsTabs = (translation: Translation, isEntraLess: boolean): TabsType[] => [
  ...(isEntraLess
    ? []
    : [
        {
          text: translation.permissions,
          location: '/settings/permission'
        }
      ]),
  {
    text: translation.api_keys,
    location: '/settings/api-keys'
  }
];
